import { useI18n } from "../i18n";

const advantages = [
    {
        icon: (
            <svg viewBox="0 0 24 24" fill="none" className="h-7 w-7">
                <path
                    d="M12 3 20 6V11C20 16 16.5 19.5 12 21C7.5 19.5 4 16 4 11V6L12 3Z"
                    stroke="currentColor"
                    strokeWidth="1.7"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.5 12L11 14.5L15.5 10"
                    stroke="currentColor"
                    strokeWidth="1.7"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
    },
    {
        icon: (
            <svg viewBox="0 0 24 24" fill="none" className="h-7 w-7">
                <path
                    d="M3 7H14V17H3V7Z"
                    stroke="currentColor"
                    strokeWidth="1.7"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 10H18L21 13V17H14V10Z"
                    stroke="currentColor"
                    strokeWidth="1.7"
                    strokeLinejoin="round"
                />
                <circle cx="7.5" cy="18" r="2" stroke="currentColor" strokeWidth="1.7" />
                <circle cx="17.5" cy="18" r="2" stroke="currentColor" strokeWidth="1.7" />
            </svg>
        ),
    },
    {
        icon: (
            <svg viewBox="0 0 24 24" fill="none" className="h-7 w-7">
                <path
                    d="M4 5H20V16H13L8 20V16H4V5Z"
                    stroke="currentColor"
                    strokeWidth="1.7"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 9H16M8 12H14"
                    stroke="currentColor"
                    strokeWidth="1.7"
                    strokeLinecap="round"
                />
            </svg>
        ),
    },
    {
        icon: (
            <svg viewBox="0 0 24 24" fill="none" className="h-7 w-7">
                <path
                    d="M3 21H21M5 21V7L12 3L19 7V21M9 10H10M14 10H15M9 14H10M14 14H15M10 21V17H14V21"
                    stroke="currentColor"
                    strokeWidth="1.7"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
    },
];

const AboutAdvantages = () => {
    const { about } = useI18n();

    return (
        <section className="relative overflow-hidden bg-slate-50 px-6 py-20 md:px-12 md:py-28">
            <div className="mx-auto max-w-7xl">
                <div className="mb-12 max-w-3xl md:mb-16">
                    <p className="mb-4 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.22em] text-sky-700 sm:text-sm">
                        <span className="h-px w-8 bg-sky-500" />
                        {about.advantagesEyebrow}
                    </p>

                    <h2 className="text-3xl font-extrabold tracking-tight text-slate-900 md:text-5xl">
                        {about.advantagesTitle}
                    </h2>

                    <p className="mt-5 max-w-2xl leading-7 text-slate-600">
                        {about.advantagesIntro}
                    </p>
                </div>

                <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
                    {about.advantages.map((item, index) => (
                        <article
                            key={index}
                            className="group rounded-2xl border border-slate-200 bg-white p-6 transition-colors duration-200 hover:border-sky-300 sm:p-7"
                        >
                            <div className="flex items-center justify-between">
                                <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-sky-50 text-sky-600 transition-colors duration-200 group-hover:bg-sky-600 group-hover:text-white">
                                    {advantages[index].icon}
                                </div>

                                <span className="text-sm font-bold text-slate-300">
                                    0{index + 1}
                                </span>
                            </div>

                            <h3 className="mt-7 text-xl font-bold text-slate-900">
                                {item.title}
                            </h3>

                            <p className="mt-3 text-sm leading-7 text-slate-600">
                                {item.description}
                            </p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default AboutAdvantages;